export default __webpack_public_path__ + "static/rhapsody-293b782eafa9eb1348e57039a025c3eb.png";